import React from "react";
import "./FunnelChart.css";

// Sequential magnitude across ordered funnel stages -> one hue, light->dark
// ramp (dataviz: choosing-a-form.md), not categorical color.
const RAMP = ["#b9d6f2", "#8ebbe8", "#5f9bdb", "#2a78d6"];

const FunnelChart = ({ stages }) => {
  if (!stages || stages.length === 0) {
    return <div className="funnel-empty">No status funnel data for the current filters.</div>;
  }

  const maxCount = Math.max(...stages.map((s) => s.count || 0), 1);
  const first = stages[0]?.count || 0;

  return (
    <div className="funnel-chart">
      {stages.map((stage, idx) => {
        const pct = Math.max(((stage.count || 0) / maxCount) * 100, 2);
        const ofFirst = first > 0 ? (((stage.count || 0) / first) * 100).toFixed(0) : "0";
        const color = RAMP[Math.min(idx, RAMP.length - 1)];
        return (
          <div key={stage.key} className="funnel-row">
            <div className="funnel-label-group">
              <span className="funnel-label" title={stage.label}>{stage.label}</span>
              {stage.sla && <span className="funnel-stage-sla">{stage.sla}</span>}
            </div>
            <div className="funnel-track">
              <div className="funnel-fill" style={{ width: `${pct}%`, background: color }} />
            </div>
            <span className="funnel-value">
              {(stage.count || 0).toLocaleString()}
              <span className="funnel-pct"> ({ofFirst}% of {stages[0]?.label})</span>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelChart;
